import { Component, input } from '@angular/core';
import { SharedModule } from '@app/modules/shared.module';
import { AcquisitionLangage, FirstDA } from '@app/models/carnet-liaison';
import {
  getFirstDate,
  formatFirstDate,
  getItemsToShow,
} from '../../carnet-liaison.utils';
import { LANGAGE_LABELS } from '../../carnet-liaison.constants';

@Component({
  selector: 'app-carnet-langage',
  templateUrl: './carnet-langage.component.html',
  styleUrl: './carnet-langage.component.scss',
  standalone: true,
  imports: [SharedModule],
})
export class CarnetLangageComponent {
  data = input<AcquisitionLangage | null>(null);
  firstDA = input<FirstDA | null>(null);
  selectedDate = input<Date | null>(null);

  readonly langageLabels = LANGAGE_LABELS;

  formatFirstDate = formatFirstDate;

  getFirstDate(fieldName: string, optionKey: string): string | null {
    return getFirstDate(this.firstDA(), 'DA_acquisitionLangage', fieldName, optionKey);
  }

  getVisibleItems(obj: Record<string, boolean> | null | undefined, labels: Record<string, string>, fieldName: string): { label: string; key: string }[] {
    return getItemsToShow(obj ?? {}, labels, this.firstDA(), 'DA_acquisitionLangage', fieldName, this.selectedDate());
  }
}
